module.exports = __webpack_public_path__ + "img/tackled_left.eec0f36a.jpg";